import { useState } from 'react';
import { useLang } from '../../../hooks/useLang';

interface AuthModalProps {
  open: boolean;
  onClose: () => void;
  onLogin: (user: { id: string; username: string; email: string; avatar: string; role: 'admin' | 'member' }) => void;
}

const ADMIN_EMAIL = '13810001256@126.com';
const ADMIN_PASS = 'admin123456';

const AUTH_LABELS: Record<string, Record<string, string>> = {
  welcomeBack: { zh: '欢迎回来', en: 'Welcome Back', fr: 'Bienvenue', es: 'Bienvenido', pt: 'Bem-vindo', ja: 'おかえりなさい', de: 'Willkommen zurück', ko: '다시 오셨군요', ar: 'مرحباً بعودتك', ru: 'С возвращением' },
  joinForum: { zh: '加入 RWA99 论坛', en: 'Join RWA99 Forum', fr: 'Rejoindre le Forum RWA99', es: 'Unirse al Foro RWA99', pt: 'Entrar no Fórum RWA99', ja: 'RWA99フォーラムに参加', de: 'RWA99 Forum beitreten', ko: 'RWA99 포럼 가입', ar: 'انضم إلى منتدى RWA99', ru: 'Присоединиться к форуму RWA99' },
  loginSubtitle: { zh: '请登录以参与讨论和分享', en: 'Login to join discussions and share', fr: 'Connectez-vous pour participer aux discussions', es: 'Inicie sesión para participar en debates', pt: 'Faça login para participar das discussões', ja: 'ログインして議論に参加', de: 'Anmelden um an Diskussionen teilzunehmen', ko: '로그인하여 토론에 참여하세요', ar: 'سجل الدخول للمشاركة في النقاشات', ru: 'Войдите для участия в обсуждениях' },
  registerSubtitle: { zh: '注册后即可发帖、回复及上传文件', en: 'Register to post, reply and upload files', fr: 'Inscrivez-vous pour publier, répondre et télécharger', es: 'Regístrese para publicar, responder y subir archivos', pt: 'Registre-se para postar, responder e enviar arquivos', ja: '登録して投稿、返信、ファイルアップロードが可能に', de: 'Registrieren um Beiträge zu erstellen und Dateien hochzuladen', ko: '가입하여 게시, 답글 및 파일 업로드', ar: 'سجل للنشر والرد ورفع الملفات', ru: 'Зарегистрируйтесь для публикаций и загрузки файлов' },
  login: { zh: '登录', en: 'Login', fr: 'Connexion', es: 'Iniciar sesión', pt: 'Entrar', ja: 'ログイン', de: 'Anmelden', ko: '로그인', ar: 'تسجيل الدخول', ru: 'Войти' },
  register: { zh: '注册', en: 'Register', fr: 'S\'inscrire', es: 'Registrarse', pt: 'Registrar', ja: '登録', de: 'Registrieren', ko: '회원가입', ar: 'التسجيل', ru: 'Регистрация' },
  username: { zh: '用户名', en: 'Username', fr: 'Nom d\'utilisateur', es: 'Nombre de usuario', pt: 'Nome de usuário', ja: 'ユーザー名', de: 'Benutzername', ko: '사용자명', ar: 'اسم المستخدم', ru: 'Имя пользователя' },
  usernamePlaceholder: { zh: '请输入用户名（2-20字符）', en: 'Enter username (2-20 chars)', fr: 'Entrez le nom d\'utilisateur (2-20 caractères)', es: 'Ingrese nombre de usuario (2-20 caracteres)', pt: 'Digite o nome de usuário (2-20 caracteres)', ja: 'ユーザー名を入力（2-20文字）', de: 'Benutzername eingeben (2-20 Zeichen)', ko: '사용자명 입력 (2-20자)', ar: 'أدخل اسم المستخدم (2-20 حرف)', ru: 'Введите имя пользователя (2-20 символов)' },
  email: { zh: '邮箱', en: 'Email', fr: 'E-mail', es: 'Correo electrónico', pt: 'E-mail', ja: 'メールアドレス', de: 'E-Mail', ko: '이메일', ar: 'البريد الإلكتروني', ru: 'Электронная почта' },
  emailPlaceholder: { zh: '请输入邮箱地址', en: 'Enter your email address', fr: 'Entrez votre adresse e-mail', es: 'Ingrese su correo electrónico', pt: 'Digite seu endereço de e-mail', ja: 'メールアドレスを入力', de: 'E-Mail-Adresse eingeben', ko: '이메일 주소 입력', ar: 'أدخل عنوان بريدك الإلكتروني', ru: 'Введите адрес электронной почты' },
  password: { zh: '密码', en: 'Password', fr: 'Mot de passe', es: 'Contraseña', pt: 'Senha', ja: 'パスワード', de: 'Passwort', ko: '비밀번호', ar: 'كلمة المرور', ru: 'Пароль' },
  passwordLoginPlaceholder: { zh: '请输入密码', en: 'Enter your password', fr: 'Entrez votre mot de passe', es: 'Ingrese su contraseña', pt: 'Digite sua senha', ja: 'パスワードを入力', de: 'Passwort eingeben', ko: '비밀번호 입력', ar: 'أدخل كلمة المرور', ru: 'Введите пароль' },
  passwordRegisterPlaceholder: { zh: '请设置密码（至少6位）', en: 'Set password (min 6 chars)', fr: 'Définir le mot de passe (min 6 caractères)', es: 'Establecer contraseña (mín. 6 caracteres)', pt: 'Definir senha (mín. 6 caracteres)', ja: 'パスワードを設定（6文字以上）', de: 'Passwort festlegen (min. 6 Zeichen)', ko: '비밀번호 설정 (최소 6자)', ar: 'تعيين كلمة المرور (6 أحرف على الأقل)', ru: 'Установите пароль (мин. 6 символов)' },
  confirmPassword: { zh: '确认密码', en: 'Confirm Password', fr: 'Confirmer le mot de passe', es: 'Confirmar contraseña', pt: 'Confirmar senha', ja: 'パスワードを確認', de: 'Passwort bestätigen', ko: '비밀번호 확인', ar: 'تأكيد كلمة المرور', ru: 'Подтвердите пароль' },
  confirmPasswordPlaceholder: { zh: '再次输入密码', en: 'Re-enter password', fr: 'Ressaisissez le mot de passe', es: 'Vuelva a ingresar la contraseña', pt: 'Digite a senha novamente', ja: 'パスワードを再入力', de: 'Passwort erneut eingeben', ko: '비밀번호 재입력', ar: 'أعد إدخال كلمة المرور', ru: 'Повторите пароль' },
  bio: { zh: '个人简介（选填）', en: 'Bio (optional)', fr: 'Biographie (optionnel)', es: 'Biografía (opcional)', pt: 'Biografia (opcional)', ja: '自己紹介（任意）', de: 'Biografie (optional)', ko: '자기소개 (선택)', ar: 'السيرة الذاتية (اختياري)', ru: 'О себе (необязательно)' },
  bioPlaceholder: { zh: '介绍一下自己的背景和研究方向...', en: 'Introduce your background and research interests...', fr: 'Présentez votre parcours et vos intérêts...', es: 'Presente su experiencia e intereses...', pt: 'Apresente seu histórico e interesses...', ja: '自分の背景と研究分野を紹介...', de: 'Stellen Sie Ihren Hintergrund vor...', ko: '배경과 연구 분야를 소개하세요...', ar: 'قدم خلفيتك واهتماماتك البحثية...', ru: 'Расскажите о своем опыте и интересах...' },
  complianceNotice: { zh: '注册即表示您同意遵守本论坛合规规范，不发布违反中国内地及香港法律法规的内容，不提供任何形式的投资建议。', en: 'By registering, you agree to comply with forum rules, not post content violating Mainland China/HK laws, and not provide investment advice.', fr: 'En vous inscrivant, vous acceptez de respecter les règles du forum, de ne pas publier de contenu illégal et de ne pas fournir de conseils en investissement.', es: 'Al registrarse, acepta cumplir las normas del foro, no publicar contenido ilegal y no proporcionar asesoramiento de inversión.', pt: 'Ao se registrar, você concorda em cumprir as regras do fórum, não publicar conteúdo ilegal e não fornecer aconselhamento de investimento.', ja: '登録することで、フォーラムのルールを遵守し、違法なコンテンツを投稿せず、投資アドバイスを提供しないことに同意します。', de: 'Mit der Registrierung stimmen Sie zu, die Forenregeln einzuhalten, keine illegalen Inhalte zu veröffentlichen und keine Anlageberatung zu geben.', ko: '가입함으로써 포럼 규칙을 준수하고, 불법 콘텐츠를 게시하지 않으며, 투자 조언을 제공하지 않는 것에 동의합니다.', ar: 'بالتسجيل، توافق على الامتثال لقواعد المنتدى وعدم نشر محتوى مخالف للقانون وعدم تقديم نصائح استثمارية.', ru: 'Регистрируясь, вы соглашаетесь соблюдать правила форума, не публиковать незаконный контент и не давать инвестиционных советов.' },
  loginBtn: { zh: '登录', en: 'Login', fr: 'Se connecter', es: 'Iniciar sesión', pt: 'Entrar', ja: 'ログイン', de: 'Anmelden', ko: '로그인', ar: 'تسجيل الدخول', ru: 'Войти' },
  registerBtn: { zh: '立即注册', en: 'Register Now', fr: 'S\'inscrire maintenant', es: 'Registrarse ahora', pt: 'Registrar agora', ja: '今すぐ登録', de: 'Jetzt registrieren', ko: '지금 가입하기', ar: 'سجل الآن', ru: 'Зарегистрироваться' },
  loggingIn: { zh: '登录中...', en: 'Logging in...', fr: 'Connexion...', es: 'Iniciando sesión...', pt: 'Entrando...', ja: 'ログイン中...', de: 'Anmelden...', ko: '로그인 중...', ar: 'جارٍ تسجيل الدخول...', ru: 'Вход...' },
  registering: { zh: '注册中...', en: 'Registering...', fr: 'Inscription...', es: 'Registrando...', pt: 'Registrando...', ja: '登録中...', de: 'Registrieren...', ko: '가입 중...', ar: 'جارٍ التسجيل...', ru: 'Регистрация...' },
  noAccount: { zh: '还没有账号？', en: 'No account yet?', fr: 'Pas encore de compte?', es: '¿No tiene cuenta?', pt: 'Ainda não tem conta?', ja: 'アカウントをお持ちでないですか？', de: 'Noch kein Konto?', ko: '계정이 없으신가요?', ar: 'ليس لديك حساب؟', ru: 'Нет аккаунта?' },
  hasAccount: { zh: '已有账号？', en: 'Already have an account?', fr: 'Vous avez déjà un compte?', es: '¿Ya tiene una cuenta?', pt: 'Já tem uma conta?', ja: 'すでにアカウントをお持ちですか？', de: 'Bereits ein Konto?', ko: '이미 계정이 있으신가요?', ar: 'لديك حساب بالفعل؟', ru: 'Уже есть аккаунт?' },
  goRegister: { zh: '立即注册', en: 'Register Now', fr: 'S\'inscrire', es: 'Registrarse', pt: 'Registrar', ja: '今すぐ登録', de: 'Jetzt registrieren', ko: '지금 가입', ar: 'سجل الآن', ru: 'Зарегистрироваться' },
  goLogin: { zh: '去登录', en: 'Login', fr: 'Se connecter', es: 'Iniciar sesión', pt: 'Entrar', ja: 'ログイン', de: 'Anmelden', ko: '로그인', ar: 'تسجيل الدخول', ru: 'Войти' },
  errEmailPassword: { zh: '请填写邮箱和密码', en: 'Please enter email and password', fr: 'Veuillez saisir l\'e-mail et le mot de passe', es: 'Por favor ingrese correo y contraseña', pt: 'Por favor insira e-mail e senha', ja: 'メールアドレスとパスワードを入力してください', de: 'Bitte E-Mail und Passwort eingeben', ko: '이메일과 비밀번호를 입력하세요', ar: 'الرجاء إدخال البريد الإلكتروني وكلمة المرور', ru: 'Введите email и пароль' },
  errWrongPassword: { zh: '密码错误，请重新输入', en: 'Wrong password, please try again', fr: 'Mot de passe incorrect, réessayez', es: 'Contraseña incorrecta, intente de nuevo', pt: 'Senha incorreta, tente novamente', ja: 'パスワードが間違っています', de: 'Falsches Passwort, bitte erneut versuchen', ko: '비밀번호가 틀렸습니다', ar: 'كلمة المرور خاطئة، حاول مرة أخرى', ru: 'Неверный пароль, попробуйте снова' },
  errNotRegistered: { zh: '该邮箱尚未注册，请先注册', en: 'Email not registered, please register first', fr: 'E-mail non enregistré, veuillez d\'abord vous inscrire', es: 'Correo no registrado, regístrese primero', pt: 'E-mail não registrado, registre-se primeiro', ja: 'このメールアドレスは未登録です', de: 'E-Mail nicht registriert, bitte zuerst registrieren', ko: '등록되지 않은 이메일입니다', ar: 'البريد الإلكتروني غير مسجل، يرجى التسجيل أولاً', ru: 'Email не зарегистрирован, сначала зарегистрируйтесь' },
  errFillAll: { zh: '请填写所有必填项', en: 'Please fill in all required fields', fr: 'Veuillez remplir tous les champs obligatoires', es: 'Por favor complete todos los campos requeridos', pt: 'Por favor preencha todos os campos obrigatórios', ja: 'すべての必須項目を入力してください', de: 'Bitte alle Pflichtfelder ausfüllen', ko: '모든 필수 항목을 입력하세요', ar: 'يرجى ملء جميع الحقول المطلوبة', ru: 'Заполните все обязательные поля' },
  errPasswordMismatch: { zh: '两次密码输入不一致', en: 'Passwords do not match', fr: 'Les mots de passe ne correspondent pas', es: 'Las contraseñas no coinciden', pt: 'As senhas não coincidem', ja: 'パスワードが一致しません', de: 'Passwörter stimmen nicht überein', ko: '비밀번호가 일치하지 않습니다', ar: 'كلمتا المرور غير متطابقتين', ru: 'Пароли не совпадают' },
  errPasswordShort: { zh: '密码至少6位', en: 'Password must be at least 6 characters', fr: 'Le mot de passe doit comporter au moins 6 caractères', es: 'La contraseña debe tener al menos 6 caracteres', pt: 'A senha deve ter pelo menos 6 caracteres', ja: 'パスワードは6文字以上必要です', de: 'Passwort muss mindestens 6 Zeichen haben', ko: '비밀번호는 최소 6자 이상이어야 합니다', ar: 'يجب أن تكون كلمة المرور 6 أحرف على الأقل', ru: 'Пароль должен содержать не менее 6 символов' },
  errInvalidEmail: { zh: '请输入有效的邮箱地址', en: 'Please enter a valid email address', fr: 'Veuillez entrer une adresse e-mail valide', es: 'Por favor ingrese una dirección de correo válida', pt: 'Por favor insira um endereço de e-mail válido', ja: '有効なメールアドレスを入力してください', de: 'Bitte gültige E-Mail-Adresse eingeben', ko: '유효한 이메일 주소를 입력하세요', ar: 'الرجاء إدخال عنوان بريد إلكتروني صالح', ru: 'Введите действительный адрес электронной почты' },
  errEmailExists: { zh: '该邮箱已注册，请直接登录', en: 'Email already registered, please login', fr: 'E-mail déjà enregistré, veuillez vous connecter', es: 'Correo ya registrado, inicie sesión', pt: 'E-mail já registrado, faça login', ja: 'このメールアドレスは既に登録されています', de: 'E-Mail bereits registriert, bitte anmelden', ko: '이미 등록된 이메일입니다', ar: 'البريد الإلكتروني مسجل بالفعل، يرجى تسجيل الدخول', ru: 'Email уже зарегистрирован, войдите' },
  successRegistered: { zh: '注册成功！正在登录...', en: 'Registration successful! Logging in...', fr: 'Inscription réussie! Connexion en cours...', es: '¡Registro exitoso! Iniciando sesión...', pt: 'Registro bem-sucedido! Entrando...', ja: '登録成功！ログイン中...', de: 'Registrierung erfolgreich! Anmelden...', ko: '가입 성공! 로그인 중...', ar: 'تم التسجيل بنجاح! جارٍ تسجيل الدخول...', ru: 'Регистрация успешна! Вход...' },
};

export default function AuthModal({ open, onClose, onLogin }: AuthModalProps) {
  const [mode, setMode] = useState<'login' | 'register'>('login');
  const [form, setForm] = useState({ username: '', email: '', password: '', confirm: '', bio: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const { lang } = useLang();

  const getLabel = (key: string) => AUTH_LABELS[key]?.[lang] ?? AUTH_LABELS[key]?.['en'] ?? key;

  if (!open) return null;

  const handleLogin = () => {
    setError('');
    if (!form.email || !form.password) {
      setError(getLabel('errEmailPassword'));
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      if (form.email === ADMIN_EMAIL && form.password === ADMIN_PASS) {
        onLogin({ id: 'admin', username: 'RWA99管理员', email: ADMIN_EMAIL, avatar: 'R', role: 'admin' });
        onClose();
      } else {
        const stored = localStorage.getItem(`bbs_user_${form.email}`);
        if (stored) {
          const u = JSON.parse(stored);
          if (u.password === form.password) {
            onLogin({ id: u.id, username: u.username, email: u.email, avatar: u.username[0], role: 'member' });
            onClose();
          } else {
            setError(getLabel('errWrongPassword'));
          }
        } else {
          setError(getLabel('errNotRegistered'));
        }
      }
    }, 600);
  };

  const handleRegister = () => {
    setError('');
    if (!form.username || !form.email || !form.password || !form.confirm) {
      setError(getLabel('errFillAll'));
      return;
    }
    if (form.password !== form.confirm) {
      setError(getLabel('errPasswordMismatch'));
      return;
    }
    if (form.password.length < 6) {
      setError(getLabel('errPasswordShort'));
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(form.email)) {
      setError(getLabel('errInvalidEmail'));
      return;
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      const existing = localStorage.getItem(`bbs_user_${form.email}`);
      if (existing) {
        setError(getLabel('errEmailExists'));
        return;
      }
      const newUser = {
        id: `u_${Date.now()}`,
        username: form.username,
        email: form.email,
        password: form.password,
        bio: form.bio,
        role: 'member',
        joinDate: new Date().toISOString().slice(0, 10),
        postCount: 0,
      };
      localStorage.setItem(`bbs_user_${form.email}`, JSON.stringify(newUser));
      const userList: string[] = JSON.parse(localStorage.getItem('bbs_user_list') || '[]');
      userList.push(form.email);
      localStorage.setItem('bbs_user_list', JSON.stringify(userList));
      setSuccess(getLabel('successRegistered'));
      setTimeout(() => {
        onLogin({ id: newUser.id, username: newUser.username, email: newUser.email, avatar: newUser.username[0], role: 'member' });
        onClose();
      }, 800);
    }, 600);
  };

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-[#2E1065] to-[#4C1D95] p-6 text-white">
          <div className="flex items-center justify-between">
            <div>
              <h2 className="font-black text-xl">
                {mode === 'login' ? getLabel('welcomeBack') : getLabel('joinForum')}
              </h2>
              <p className="text-white/60 text-xs mt-1">
                {mode === 'login' ? getLabel('loginSubtitle') : getLabel('registerSubtitle')}
              </p>
            </div>
            <button onClick={onClose} className="w-8 h-8 flex items-center justify-center text-white/60 hover:text-white transition-colors cursor-pointer">
              <i className="ri-close-line text-xl" />
            </button>
          </div>
          {/* Tab */}
          <div className="flex gap-1 mt-4 bg-white/10 p-1 rounded-full w-fit">
            {(['login', 'register'] as const).map((m) => (
              <button
                key={m}
                onClick={() => { setMode(m); setError(''); setSuccess(''); }}
                className={`px-4 py-1.5 rounded-full text-xs font-bold transition-all cursor-pointer whitespace-nowrap ${mode === m ? 'bg-white text-[#7C3AED]' : 'text-white/70 hover:text-white'}`}
              >
                {m === 'login' ? getLabel('login') : getLabel('register')}
              </button>
            ))}
          </div>
        </div>

        {/* Form */}
        <div className="p-6 space-y-4">
          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              <i className="ri-error-warning-line shrink-0" />
              {error}
            </div>
          )}
          {success && (
            <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg text-green-600 text-sm">
              <i className="ri-check-line shrink-0" />
              {success}
            </div>
          )}

          {mode === 'register' && (
            <div>
              <label className="text-xs font-bold text-gray-600 block mb-1.5">{getLabel('username')} *</label>
              <input
                type="text"
                value={form.username}
                onChange={(e) => setForm({ ...form, username: e.target.value })}
                placeholder={getLabel('usernamePlaceholder')}
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors"
              />
            </div>
          )}

          <div>
            <label className="text-xs font-bold text-gray-600 block mb-1.5">{getLabel('email')} *</label>
            <input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder={getLabel('emailPlaceholder')}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors"
            />
          </div>

          <div>
            <label className="text-xs font-bold text-gray-600 block mb-1.5">{getLabel('password')} *</label>
            <input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              placeholder={mode === 'login' ? getLabel('passwordLoginPlaceholder') : getLabel('passwordRegisterPlaceholder')}
              className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors"
            />
          </div>

          {mode === 'register' && (
            <>
              <div>
                <label className="text-xs font-bold text-gray-600 block mb-1.5">{getLabel('confirmPassword')} *</label>
                <input
                  type="password"
                  value={form.confirm}
                  onChange={(e) => setForm({ ...form, confirm: e.target.value })}
                  placeholder={getLabel('confirmPasswordPlaceholder')}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors"
                />
              </div>
              <div>
                <label className="text-xs font-bold text-gray-600 block mb-1.5">{getLabel('bio')}</label>
                <textarea
                  value={form.bio}
                  onChange={(e) => setForm({ ...form, bio: e.target.value })}
                  placeholder={getLabel('bioPlaceholder')}
                  rows={2}
                  className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-[#7C3AED] transition-colors resize-none"
                  maxLength={200}
                />
              </div>
              <div className="flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg">
                <i className="ri-shield-check-line text-amber-600 text-sm mt-0.5 shrink-0" />
                <p className="text-amber-700 text-xs leading-relaxed">
                  {getLabel('complianceNotice')}
                </p>
              </div>
            </>
          )}

          <button
            onClick={mode === 'login' ? handleLogin : handleRegister}
            disabled={loading}
            className="w-full py-3 bg-gradient-to-r from-[#7C3AED] to-[#A855F7] text-white font-black rounded-xl hover:opacity-90 transition-opacity cursor-pointer disabled:opacity-50 whitespace-nowrap"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <i className="ri-loader-4-line animate-spin" />
                {mode === 'login' ? getLabel('loggingIn') : getLabel('registering')}
              </span>
            ) : (
              mode === 'login' ? getLabel('loginBtn') : getLabel('registerBtn')
            )}
          </button>

          <p className="text-center text-xs text-gray-400">
            {mode === 'login' ? getLabel('noAccount') : getLabel('hasAccount')}
            <button
              onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setError(''); }}
              className="text-[#7C3AED] font-bold ml-1 cursor-pointer hover:underline"
            >
              {mode === 'login' ? getLabel('goRegister') : getLabel('goLogin')}
            </button>
          </p>
        </div>
      </div>
    </div>
  );
}
